export default "__VITE_ASSET__DF0Qd_gN__"